import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { airconHero } from "@/mocks/airconData";
import { Link } from "react-router-dom";

export default function AirconHero() {
  return (
    <section className="relative min-h-[420px] md:min-h-[520px] lg:min-h-[600px] flex items-center justify-center overflow-hidden bg-tie-navy">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=International research conference stage with large screen displaying textile innovation presentation, audience of professionals in modern convention hall, warm earth tone lighting, professional conference setting with podium and microphones, cream and terracotta interior accents, horizontal composition"
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-tie-navy/70 via-tie-navy/50 to-tie-navy/90" />
      </div>

      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-[0.04]">
        <div className="absolute top-0 left-[25%] w-px h-full bg-white" />
        <div className="absolute top-0 left-[50%] w-px h-full bg-white" />
        <div className="absolute top-0 left-[75%] w-px h-full bg-white" />
        <div className="absolute top-[40%] left-0 w-full h-px bg-white" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 pb-12 md:pb-16">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 mb-5 md:mb-6">
              <span className="w-2 h-2 rounded-full bg-tie-teal-light animate-pulse" />
              <span className="text-xs md:text-sm text-white/80 font-medium tracking-wide uppercase">
                {airconHero.badge}
              </span>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              {airconHero.title}
            </h1>
          </ScrollReveal>

          <ScrollReveal delay={200}>
            <p className="mt-5 md:mt-6 text-base md:text-lg lg:text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
              {airconHero.subtitle}
            </p>
          </ScrollReveal>

          <ScrollReveal delay={350}>
            <div className="mt-7 md:mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/collaborate"
                className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-tie-teal text-white font-medium text-sm hover:bg-tie-teal-dark transition-all duration-300 whitespace-nowrap"
              >
                {airconHero.ctaPrimary}
                <i className="ri-arrow-right-line ml-2" />
              </Link>
              <a
                href="#tracks"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#tracks")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-white/10 text-white border border-white/30 font-medium text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                {airconHero.ctaSecondary}
                <i className="ri-arrow-down-line ml-2" />
              </a>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}